import { styled, Box } from "@mui/material";

const WelcomePageButtonBox = styled(Box)(({ theme }) => ({
  padding: "32px 24px",
  display: "flex",
  flexDirection: "column",
  gap: "17px",
}));

export default WelcomePageButtonBox;
